import { rest } from 'msw';

export const sanctumHandlers = [
  rest.get(`${process.env.BACKEND_URL}/sanctum/csrf-cookie`, (_, res, ctx) =>
    res(ctx.status(204), ctx.cookie('XSRF-TOKEN', 'mock-token'))
  ),
];
